import { makeTraceHttpRequestHeaders } from "./utils/make-trace-http-request-headers";

import type { TraceIdContextStateType } from "./types";

const state: TraceIdContextStateType = {
    context: null
};

export const setActiveTrace = (
    traceId: string,
    sampled: string,
    spanId: string,
    type: string
) => {
    state.context = {
        traceId,
        sampled,
        spanId,
        type
    };
};

export const getActiveTrace = () => state.context || undefined;

export const clearActiveTrace = () => {
    state.context = null;
};

export const getActiveTraceHttpRequestHeaders = (_url: string) => {
    if (state.context === null) return null;

    const { traceId, sampled, spanId } = state.context;
    return makeTraceHttpRequestHeaders(traceId, sampled, spanId);
};
